// Key values that are repeated a lot
const defaultFieldLogic = {
  // tells the form to render the field
  shouldRender: true,
  // tells the form to validate the field
  shouldValidate: true,
  // vodafone requirement to overwite the user submitted value in some cases.
  overwriteSubmit: {
    overwrite: false,
    overwriteValue: null,
  },
  // in some cases a field will be disabled and a value will be asigned to it
  disabledFieldOptions: {
    disabled: false,
    disabledValue: null,
    // value to default back to if it is no longer disabled
    unDisabledValue: null,
  },
  optional: false,
  readOnly: false,
};

export { defaultFieldLogic };
